module.exports = __webpack_public_path__ + "static/media/MHRM00N0003.b61f3eb7.svg";